<template>
  <component :is="icon" />
</template>

<script>
import booking from "./booking";
import flights from "./flights";
import masters from "./masters";
import miscellaneous from "./miscellaneous";
import packages from "./packages";
import quotation from "./quotation";
import reports from "./reports";
import security from "./security";
import storage from "./storage";
import payments from "./payments";
import cruise from "./cruise";
export default {
  name: "Icon",
  props: {
    icon: { type: String, default: "security" }
  },
  components: {
    booking,
    flights,
    masters,
    miscellaneous,
    packages,
    packages,
    quotation,
    reports,
    security,
    storage,
    payments,
    cruise
  }
};
</script>

<style></style>
